import { post, put } from 'api/methods';
import { FlagColaborador } from 'helpers/enums/TipoColaborador';

interface AssociadoSearchRequest {
  nomeCpfCnpj: string;
}

interface AssociadoSearchItem {
  codigoAgencia: string;
  codigoCooperativa: string;
  cpfCnpj: string;
  flgColaborador: number;
  id: number;
  nome: string;
  numeroConta: string;
  numeroNucleo: string;
}

export type AssociadoSearchResponse = Array<AssociadoSearchItem>;

export interface AssociadoUpdateRequest {
  flgColaborador: FlagColaborador;
  oidAssociado: number;
}

const associado = {
  search: (request: AssociadoSearchRequest) => {
    return post<AssociadoSearchResponse>(
      'assembleiasAssessor',
      'associado/search',
      request
    );
  },
  update: (request: AssociadoUpdateRequest) => {
    return put('assembleiasAssessor', 'associado/flg-colaborador', request);
  },
};

export default associado;
